import React from "react";
import PropTypes from "prop-types";
import { PlusOutlineGradientIcon } from "wm-graphics";
import { Tooltip } from "../../Tooltip/Tooltip";
import { withTranslations } from "../../../../utils/withTranslations";
import defaultLocales from "./locales";
import "./AddRowButton.scss";

const ENTER_KEY = "Enter";

export class UAddRowButton extends React.Component {
  static propTypes = {
    onRowAdd: PropTypes.func,
    locales: PropTypes.shape({
      addRow: PropTypes.string,
    }),
  };

  onKeyDownHandler = (event) => {
    const { onRowAdd } = this.props;
    if (event.key === ENTER_KEY) {
      onRowAdd();
    }
  };

  render() {
    const { locales, onRowAdd } = this.props;
    return (
      <Tooltip content={locales.addRow} direction="bottom">
        <div
          className="AddRowButton"
          onClick={onRowAdd}
          onKeyDown={this.onKeyDownHandler}
          tabIndex={0}
          role="button"
        >
          <PlusOutlineGradientIcon data-testid="addRowIcon" />
        </div>
      </Tooltip>
    );
  }
}

const translatedAddRowButton = withTranslations(defaultLocales)(UAddRowButton);

export { translatedAddRowButton as AddRowButton };

export default translatedAddRowButton;
